import React, { PropsWithChildren, useContext } from "react";
import { Navigate } from "react-router";
import {
    AuthContextObject,
    AuthenticatedUserContext,
} from "../contexts/AuthenticatedUserContext";
import useSelectedMunicipalityId from "../hooks/useSelectedMunicipalityId";
import { routes } from "../routes";
import Loader from "./Loader";

interface Props {
    canAccess: (user: AuthContextObject) => boolean;
}

const MunicipalityRoleAuthorized = ({
    canAccess,
    children,
}: PropsWithChildren<Props>) => {
    const { authUserData } = useContext(AuthenticatedUserContext);
    const municipalityId = useSelectedMunicipalityId();

    const isAuthorized = authUserData ? canAccess(authUserData) : undefined;

    if (isAuthorized === true) {
        return <>{children}</>;
    }

    if (isAuthorized === false) {
        return <Navigate to={routes.customers(municipalityId)} replace />;
    }

    return <Loader fullHeight />;
};

export default MunicipalityRoleAuthorized;
